/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { ApiKey } from "./ApiKey";
export const PublishableKeyResponse = core.serialization.object({
    data: ApiKey,
});
